'use client';

import { CardDirection, GlowCard, CardProps } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

export const UIBrandCorner: Component<CardProps> = (props) => {
    return (
        <GlowCard
            {...props}
            direction={CardDirection.TabletRow}
            image={{
                src: props.image?.src,
                classNames: {
                    image: 'aspect-[457/317]',
                    wrapper: 'tablet:max-w-[28.563rem]',
                },
            }}
        />
    );
};
